export default "__VITE_ASSET__CuPOcE1Q__"